import { Button } from 'blaze-ui/Button'
import { MobileWizard } from 'components/Wizards/MobileWizards/Layout'
import { ArrowRight } from 'blaze-ui/icons'
import { multiStep } from 'components/Wizards/MobileWizards/MultiStepMobileWizard/multiStep'
import { useState } from 'react'
import { MobileFieldsSection } from 'components/Wizards/MobileWizards/Form/MobileFieldsSection'

export const BlogConfig = multiStep(({ schema, submit }) => {
  const { meta } = schema.describe()
  const fields = Object.entries(schema.fields)
  const [isLoading, setIsLoading] = useState(false)

  return (
    <>
      <MobileWizard.Content>
        <MobileWizard.Section>
          <MobileWizard.Title>{meta.title}</MobileWizard.Title>
        </MobileWizard.Section>
        <MobileFieldsSection fields={fields} setIsLoading={setIsLoading} />
      </MobileWizard.Content>
      <MobileWizard.ButtonFooter>
        <Button size="lg" variant="primary" endIcon={ArrowRight} fullWidth onPress={submit} isDisabled={isLoading}>
          {meta.submitLabel}
        </Button>
      </MobileWizard.ButtonFooter>
    </>
  )
})
